var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRetail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Square_Green_Retail_Envirotainer",
    transform: "matrix(1.25,0,0,1.25,-130,-140)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M503.7,229l-37.6-97.2l-0.4-1.5l-252.6,0h-41.5h-0.3l-1.1,2.3L112.6,229h-0.2v0.4l-0.3,0.5h0.3v37.6h9.2 v16.5v9.5v215.4h379.3V293.4v-9.5v-16.5h3.2V229H503.7z M299.6,469.7H169.3V330h130.3V469.7z M446.1,433.8h-99.8v-74h99.8V433.8z  M126.7,283.9v-16.5h41v-37.8l41.8-91.3h41.1l-19.5,90.9h0v0.2l-0.1,0.4h0.1v37.9h55.7v-38.5h-0.1l6.5-90.9l40.5,0l1.6,90h-0.1 v38.5h55.9v-37.2v-0.1v-1.2h-0.2l-14.6-90l49.6,0l22.4,91.5h0.2v37.6h47v16.5H126.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/retail.729d0c79934b1a30e5ce764f71fe3dec.svg";
export { ForwardRef as ReactComponent };